// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"db47b09f","784":"e7f0804e","890":"f2b4073e","971":"b3449230"}[chunkId] + ".chunk.css";
};